import { ButtonVariants } from '../../Atoms/Button';
import { HeroComponent } from '../../Common/HeroComponent';

const HeroRewardComponent = (): JSX.Element => {
  return (
    <>
      <HeroComponent
        heading="ClearTax Rewards"
        description="Note: Exclusive offer codes will be visible on My Account page after you have successfully e-filed."
        buttons={[
          {
            text: 'eFile now',
            btnLink: '/income-tax-efiling',
            buttonVariant: ButtonVariants.bluefilled,
            type: 'link',
          },
        ]}
        containerClasses="sm:pb-7"
        imageSource="https://assets1.cleartax-cdn.com/cleartax/images/1655818135_6114ad03f7f54d4878dec4e6_group16816.png"
        mediaHeight={350}
        mediaWidth={600}
      />
    </>
  );
};

export default HeroRewardComponent;
